import React from 'react';
import { ArrowUpRight, Sparkles } from 'lucide-react';
import { WHATSAPP_LINK } from '../data/mock';
import MagneticButton from './MagneticButton';

export default function FinalCTA() {
  return (
    <section className="py-24 md:py-36 relative">
      <div className="thesis-container">
        <div className="reveal relative rounded-[12px] glass-strong overflow-hidden">
          {/* Background spotlight */}
          <div className="absolute inset-0 bg-gradient-to-br from-[#C8FF61]/10 via-transparent to-[#16E0C9]/10 pointer-events-none" />
          <div className="absolute -right-32 -bottom-40 w-[520px] h-[520px] rounded-full bg-[#C8FF61]/10 blur-3xl pointer-events-none" />

          <div className="relative z-10 grid grid-cols-1 md:grid-cols-12 gap-8 p-10 md:p-16">
            <div className="md:col-span-2">
              <span className="font-mono-label text-[#C8FF61]">(10) — Vamos?</span>
            </div>
            <div className="md:col-span-10">
              <h2 className="font-display-tight text-[48px] md:text-[100px] leading-[0.92] text-[#F5F1E8]">
                Pronto pra <span className="font-serif-italic kinetic-grad">começar?</span>
              </h2>
              <p className="mt-6 text-[16px] md:text-[19px] max-w-[540px] text-[#F5F1E8]/80 leading-relaxed">
                Escolha um plano fechado ou peça um orçamento personalizado. Em 1 hora estamos conversando.
              </p>

              <div className="mt-9 flex flex-wrap gap-3">
                <MagneticButton
                  href={WHATSAPP_LINK('Quero começar com o plano Essencial — R$300/mês.')}
                  target="_blank" rel="noopener noreferrer" className="cursor-hover"
                >
                  <span className="btn-primary">
                    R$ 300/mês · Plano Essencial
                    <ArrowUpRight size={18} />
                  </span>
                </MagneticButton>
                <a
                  href={WHATSAPP_LINK('Quero um orçamento personalizado.')}
                  target="_blank" rel="noopener noreferrer"
                  className="btn-secondary cursor-hover"
                >
                  Orçamento personalizado
                </a>
              </div>

              <div className="mt-12 pt-8 border-t border-white/8 flex flex-wrap gap-x-10 gap-y-4 text-[13px] text-[#F5F1E8]/65">
                <span className="flex items-center gap-2"><Sparkles size={14} className="text-[#C8FF61]" /> Sem fidelidade</span>
                <span className="flex items-center gap-2"><Sparkles size={14} className="text-[#C8FF61]" /> 1 rodada de ajustes grátis</span>
                <span className="flex items-center gap-2"><Sparkles size={14} className="text-[#C8FF61]" /> Resposta em até 1h</span>
                <span className="flex items-center gap-2"><Sparkles size={14} className="text-[#C8FF61]" /> PIX, boleto ou cartão</span>
              </div>
            </div>
          </div>

          <div className="absolute right-12 top-12 hidden md:flex flex-col items-end gap-1">
            <span className="font-serif-italic text-[#F5F1E8]/65 text-[18px]">desde</span>
            <span className="font-display-tight text-[120px] leading-none kinetic-grad">R$10</span>
            <span className="font-mono-label text-[#F5F1E8]/65">por dia</span>
          </div>
        </div>
      </div>
    </section>
  );
}
